export default __webpack_public_path__ + "static/breakdown-8f31ad673ee30639e7b3e9e301ea69e4.svg";